/** i18n bootstrap for the Customer Bot Dashboard. Imported once, before React mounts. */

import { initI18n } from "@nab/shared";

import ar from "./locales/ar.json";
import en from "./locales/en.json";

// English by default, like the back office and for the same reason: the people who configure the
// bot work with action keys, placeholder names and version labels that are English in the data
// itself. Arabic is one click away and the whole application mirrors — which matters more here
// than anywhere else, because half of what is being edited *is* Arabic.
initI18n({ appResources: { ar, en }, defaultLanguage: "en" });
